<script>
export default {
  name: 'BForm',
  props: {
    module: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'default',
    },
    showLoading: {
      type: Boolean,
      default: true,
    },
    showMessage: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    classies() {
      return {
        [`b-form--${this.type}`]: true,
      };
    },
    load() {
      if (!this.showLoading) {
        return false;
      }
      return this.module.loading || this.loading;
    },
  },
  methods: {
    submit(e) {
      if (e) {
        e.preventDefault();
      }
      this.module.submit()
        .then((data) => {
          this.$emit('submit', data);
        });
    },
  },
  mounted() {
    this.module.toReset();
    this.module.el = this;
  },
  destroyed() {
    this.module.toReset();
    this.module.el = null;
  },
};
</script>
<template>
  <form
    class="b-form"
    :class="classies"
    @submit="submit"
  >
    <slot></slot>
    <UlLoad v-if="load"></UlLoad>
  </form>
</template>
<style lang="scss">
  .b-form {
    display: block;
    margin: 0;
    position: relative;

    &--line {
      display: flex;

      .b-form-item__error {
        display: none !important;
      }

      .b-form-item {
        padding: 0 2px;
      }

      .b-form-item__label {
        font-size: 13px;
        padding-top: 2px;
        padding-left: 4px;
        left: 0;
        line-height: 14px;
      }


      .b-form-item__input {
        background: #f5f5f5;

        select,
        input {
          font-size: 14px;
        }

        input {
          padding: 0 4px !important;
        }
      }

      .b-form-date-picker__icon {
        margin: 0;
        width: 24px;
      }

      .b-form-item--disabled {
        .b-form-item__input {
          background: #ffffff;
        }
      }
    }
  }
</style>
